export default __webpack_public_path__ + "static/media/carrier.d832a1a3.svg";